// EScreenSize values depends on _media_queries.scss file
export enum EScreenSizeBreakPoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}

export const SCREEN_SIZE_BREAKPOINTS: Record<EScreenSizeBreakPoint, number> = {
  [EScreenSizeBreakPoint.xs]: 576,
  [EScreenSizeBreakPoint.sm]: 768,
  [EScreenSizeBreakPoint.md]: 992, // keep in sync with /theme/_variables.scss $mediumScreenBreakpoint
  [EScreenSizeBreakPoint.lg]: 1200, // keep in sync with /theme/_variables.scss $largeScreenBreakpoint
};

Object.freeze(SCREEN_SIZE_BREAKPOINTS);

export enum EViewMode {
  scoreChallengeReview = 'score-challenge-review',
}
